import React from 'react';
import ClassAssembly  from 'views/ClassAssembly4F2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
export default ClassAssemblyPage;